import RNBiometrics from 'react-native-biometrics';
import { apiConfig } from '@bonanza-social/toolkit/api';

const biometrics = new RNBiometrics();

const enable = async () => {
  const { keysExist } = await exist();

  if (keysExist) {
    await disable();
  }

  const accountId = await apiConfig.getUserId();

  if (!accountId) {
    throw new Error('BIOMETRICS_MISSING_ACCOUNT_ID');
  }

  const { publicKey } = await biometrics.createKeys();

  return { publicKey, accountId: Number(accountId) };
};

const disable = async () => {
  const { keysExist } = await exist();

  if (!keysExist) {
    return;
  }

  const { keysDeleted } = await biometrics.deleteKeys();

  if (!keysDeleted) {
    throw new Error('BIOMETRICS_DELETE_KEYS_ERROR');
  }
};

const verify = async (challenge: string) =>
  await biometrics.createSignature({
    promptMessage: 'Confirm your identity',
    payload: challenge,
  });

const verifySimple = async () =>
  await biometrics.simplePrompt({
    promptMessage: 'Confirm your identity',
  });

const exist = async () => await biometrics.biometricKeysExist();

const available = async () => await biometrics.isSensorAvailable();

export default {
  enable,
  disable,
  verify,
  verifySimple,
  exist,
  available,
};
